module.exports = __webpack_public_path__ + "img/icon.db6fc6d7.png";